/**
 * "124.75 hrs @ $170.00/hr" → "124.75 h @ $170.00/hr" — AT DISPLAY TIME ONLY.
 *
 * Hours have one unit in this app and it is `h`. "hrs" survives as a
 * documented exception because the invoice generator writes that exact string
 * INTO the line item and `line-editor.tsx` parses it back out when entries are
 * included or excluded — changing the generator would make new invoices
 * disagree with the 156 already issued.
 *
 * But the exception was showing up on the client's PDF and hosted page, which
 * is the one place our house style sits on somebody else's desk, and on the
 * staff detail view beside it. So the STORED text is untouched (the editor
 * still parses it; old invoices still say what they always said) and only
 * what is PRINTED is normalised. The server does the same thing, in
 * `backend/src/modules/invoices/invoice-document.ts#displayHoursUnit`, so the
 * sheet, the PDF and this table cannot disagree.
 *
 * The rate keeps `/hr`: "$170.00/h" is not how anybody quotes a rate.
 *
 * ⚠ Never use this inside the line EDITOR. It edits the stored string.
 */
export function displayHoursUnit(description: string): string {
  return description.replace(/(\d)\s*hrs\b/g, '$1 h');
}
